import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('showAutomaticReplyEnabledOptions', function (choice) {
    var optionState = getStore().currentState;
    optionState.isAutomaticReplyEnabled = choice;
    if (!choice) {
        optionState.declineExistingCalendarEventsEnabled = choice;
    }
});
//# sourceMappingURL=showAutomaticReplyEnabledOptions.js.map